import { AfterViewInit, Component, OnInit } from '@angular/core';
import { categoryDB } from '../../../../shared/tables/category';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LocalDataSource } from 'ng2-smart-table';
import { TagDTO } from 'src/app/shared/models/model';
import { tagService } from 'src/app/shared/service/tag.service';
import { Router } from '@angular/router';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {
    public closeResult: string;
    public Source: LocalDataSource;
    public Tag: TagDTO = new TagDTO();
    public tagList: TagDTO[] = [];



    constructor(private router: Router,private modalService: NgbModal, private tagService: tagService) {
        this.Source = new LocalDataSource();
        this.Tag = new TagDTO();
        this.tagService.getTags().subscribe(data => {
            this.tagList = data;
            this.Source = new LocalDataSource(this.tagList);
        });

        console.log(this.Source);
    }


    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    updateRecord(event) {
        console.log(event);
        this.Tag.idtag = event.newData.idtag;
        this.Tag.tag1 = event.newData.tag1;
        this.tagService.updateTag(this.Tag);
        event.confirm.resolve(event.newData);
    }

    deleteRecord(event) {
        this.Tag = new TagDTO();
        this.Tag.idtag = event.data.idtag;
        this.Tag.tag1 = event.data.tag1;
        this.tagService.deleteTag(this.Tag.idtag);
        event.confirm.resolve(event.data);
    }

    createRecord(event){
        console.log(event);
        this.Tag.idtag = event.newData.idtag;
        this.Tag.tag1 = event.newData.tag1;
        this.tagService.addTag(this.Tag);
        event.confirm.resolve(event.newData);
    }


    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    public settings = {
        "mode": "inline",
        delete: {
            "confirmDelete": "true"
        },
        edit: { "confirmSave": "true" },
        add:{"confirmCreate" : "true"},
        actions: {
            position: 'right',
            update: true
        },
        columns: {
            idtag: {
                title: 'IdTag'
            },
            tag1: {
                title: 'Tag Description'
            }
        },
    };
    ngOnInit() {
        this.Source = new LocalDataSource();
        this.loadGrid();
      }
    
      loadGrid() {
        this.tagService.getTags().subscribe(data => {
            this.tagList = data;
            this.Source = new LocalDataSource(this.tagList);
        });
      }

    onSubmit(tagForm) {
        alert("test");
        debugger
        console.log(tagForm);
        this.Tag = new TagDTO();
        this.Tag.tag1 = tagForm.value["Tag"];
        console.log(this.Tag);
        this.tagService.addTag(this.Tag);
        this.loadGrid();
        window.location.reload();
    }

}
function collapseAnimation() {
    throw new Error('Function not implemented.');
}
